import { render } from "./Trend.vue?vue&type=template&id=34cc58f1&scoped=true"
import script from "./Trend.vue?vue&type=script&lang=js"
export * from "./Trend.vue?vue&type=script&lang=js"

import "./Trend.vue?vue&type=style&index=0&id=34cc58f1&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34cc58f1"]])

export default __exports__